<template>
    <div>
        <!-- <manage-version v-if="openVersionDisplayDialog" @close="closeVersionDisplayDialog" :fileInfo="selectedFileToViewVersions" :disableUpload='true' @openPreviewOfMedia="openPreviewOfMedia"></manage-version> -->
        <div style="height:100%;overflow:auto">
            <div v-if="!enableMinimalData" v-on:click="openReplyThread(commentDetails)" class="comm-comment-wrapper w-100 d-flex" :class="{activeComment:activeCommentIndex == commentDetails._id}" :id="commentDetails._id">
                <div class="col-md-1" style="padding:0px !important">
                    
                    <div style="display: flex;width: 100%;margin: auto;justify-content: end">
                        <!-- <img draggable="false" :src="getThumbnail(commentDetails)" style="height:100%;margin:0px !important" />  -->
        
                        <!-- <img draggable="false" :src="getThumbnail(commentDetails.thumbnail_uri)" style="height:100%;margin:0px !important" />  -->
                        <!-- <div v-if="Object.keys(commentDetails).includes('profile_image') && !['undefined', undefined,null].includes(commentDetails.profile_image) && commentDetails.profile_image" v-html="getProfileImageOfUser(commentDetails.profile_image)" class='user-name-or-image user-name'>
                        </div> -->
                        <div v-if="Object.keys(commentDetails).includes('profile_image') && !['undefined',undefined,null].includes(commentDetails.profile_image) && commentDetails.profile_image">
                            <div v-for="(value, key) in commentDetails.profile_image" :key="key"> 
                                <div v-if="!['undefined',undefined,null].includes(value)"> 
                                    <div class='user-name-or-image user-name' style="float:inline-start;display:inline-block;">
                                        <img :src="getProxyConvertedURL(commentDetails.profile_image[key])" @error="replaceWithUserIcon($event,commentDetails.username)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                                    </div> 
                                </div>  
                                <div v-else class="user-name-or-image user-name" :style="style(commentDetails.username)" :title="commentDetails.username" style="top:1px !important">{{ commentDetails.username.split("")[0] }}</div>  
                            </div>       
                        </div>
                        <div v-else class="user-name-or-image user-name" :style="style(commentDetails.username)" :title="commentDetails.username" style="top:1px !important">{{ commentDetails.username.split("")[0] }}</div>
                    </div>
                </div>
                <div class="col-md-10 comment-details-div" style="text-align:start;padding:0px">  
                    <div style="display:flex;">{{commentDetails.username}}
                        <div class="commented-date" style="position:relative;inset-inline-start:8px;top:4px;font-size:11px">{{getDateAndTimeInConfiguredFormat(commentDetails.created_datetime)}}</div>
                    </div>
                    <div v-show="isCommentEdit == true">
                        <add-comment  @commentPostData="updateCommentAction" @closeEditingComment="closeCommentEdit(commentDetails.comment)" :commentDataToEdit="editCommentData"  :buttonRequiredList="['updateComment', 'cancelUpdateComment']" :commentDetails= commentDetails></add-comment>
                    </div>
                    <div v-show="isCommentEdit != true" class="comment-data-div comment-text-cursor" v-html="urlify(commentDetails.comment)"></div>
                    <div v-if="commentDetails.attachments_info && commentDetails.attachments_info.length" class='attachments-in-message'>
                        <template v-for="attachment in commentDetails.attachments_info">
                            <div v-if="Object.keys(attachment).length" :key="attachment._id" :title="attachment.file_name" v-on:dblclick="openPictureInPicture(attachment)" style="display: block;width:400px;margin-bottom:20px">
                                <div v-if="attachment.proxy_info.thumbnail_uri != undefined && attachment.proxy_info.thumbnail_uri.length" class="thumbnail-view" style="display: flex;width: 400px;justify-content: center">
                                    <img draggable="false" :src="getThumbnail(attachment)" @error="replaceByDefaultImage" style="border-radius: 5px;width:100%"/> 
                                    <div v-if="attachment.state && attachment.state == 'OUTDATED'" class="outdated-text">
                                        {{$t('OUTDATED')}}
                                    </div>
                                    <div class="storage-type-icons-wrapper">
                                        <svg @click="openPictureInPicture(attachment)" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#a3adad">
                                            <path d="M0 0h24v24H0V0z" fill="none"/>
                                            <title>Preview</title>
                                            <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                                        </svg>
                                        <svg v-if="isActionEnable('Download')" @click.stop.prevent="handleDownloadAction(attachment)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                                            <title>{{$t('Download')}}</title>
                                            <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                            <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                        </svg>
                                        <svg v-if="attachment.state && attachment.state == 'OUTDATED' && getVersionInfoDisplayCheck" v-on:click.stop.prevent="openManageVersions(attachment)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-files" viewBox="0 0 16 16">
                                            <title>{{$t('View versions')}}</title>
                                            <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div
                                v-else
                                class="svg-icons-display-wrapper"
                                style="height: 225px;display: flex;width: 100%;justify-content: center;position:relative"
                                >
                                <div v-if="attachment.state && attachment.state == 'OUTDATED'" class="outdated-text">
                                    {{$t('OUTDATED')}}
                                </div>
                                <div class="svg-icons-display" style="width:90px !important;height:90px !important" v-html="getSvgIconsOfMediaTypes(attachment)"></div>
                                    <div class="storage-type-icons-wrapper">
                                        <svg v-if="isActionEnable('Download')" @click.stop.prevent="handleDownloadAction(attachment)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                                            <title>{{$t('Download')}}</title>
                                            <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                            <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                        </svg>
                                        <svg v-if="attachment.state && attachment.state == 'OUTDATED' && getVersionInfoDisplayCheck" v-on:click.stop.prevent="openManageVersions(attachment)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-files" viewBox="0 0 16 16">
                                            <title>{{$t('View versions')}}</title>
                                            <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                                        </svg>
                                    </div>
                                </div> 
                                <div style="display:flex;" :title="attachment.file_name">
                                    <div class="svg-icons-display" v-html="getSvgIconsOfMediaTypes(attachment)">                              
                                    </div>
                                    <div style=" margin-top: 7px; text-align: start;white-space: nowrap;width: 100%;overflow: hidden;text-overflow: ellipsis;font-size:12px;margin:9px;margin-inline-start:0px">
                                        {{attachment.file_name}}
                                    </div>
                                </div>
                            </div>
                        </template>
                        </div>
                    
                    <div class="replied-by-wrapper" :style="getReplyCount(commentDetails.reply_count)!= 0?'display:block':'display:none'">
                        <!-- <div v-if="Object.keys(commentDetails).includes('profile_image') && !['undefined', undefined,null].includes(commentDetails.profile_image) && commentDetails.profile_image" v-html="getProfileImageOfUser(commentDetails.profile_image)" class='user-name-or-image user-name'>
                        </div> -->
                        <div v-if="Object.keys(commentDetails).includes('replied_profile_images') && !['undefined', undefined,null].includes(commentDetails.replied_profile_images) && commentDetails.replied_profile_images" style="display:inline-flex;float:inline-start">
                            <!-- <template  v-for="(userImg, index) in commentDetails.replied_profile_images">
                                <div v-if="!['undefined', undefined,null].includes(ucomment-textserImg)" :key="userImg" v-html="getProfileImageOfUser(userImg)" class='user-name-or-image user-name'>
                                </div>
                                <div v-else class="user-name-or-image user-name" :key="index" :style="style(commentDetails.replied_user_names[index])" :title="commentDetails.replied_user_names[index]">{{ commentDetails.replied_user_names[index].split("")[0] }}</div>
                                
                            </template> -->
                            <template  v-for="(userImgObj, index) in commentDetails.replied_profile_images">
                                <!-- <div v-if="!['undefined', undefined,null].includes(userImg)" :key="userImgObj" v-html="getProfileImageOfUser(userImg)" class='user-name-or-image user-name'>
                                </div>
                                <div v-else class="user-name-or-image user-name" :key="userImgObj" :style="style(commentDetails.replied_user_names[index])" :title="commentDetails.replied_user_names[index]">{{ commentDetails.replied_user_names[index].split("")[0] }}</div> -->
                                <div v-for="(value, key) in userImgObj" :key="key"> 
                                    <div v-if="!['undefined',undefined,null].includes(value)"> 
                                        <div class='user-name-or-image user-name' style="float:inline-start;display:inline-block;">
                                            <img :src="getProxyConvertedURL(value)" @error="replaceWithUserIcon($event,commentDetails.replied_user_names[index])" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                                        </div> 
                                    </div>  
                                    <div v-else class="user-name-or-image user-name" :key="index" :style="style(commentDetails.replied_user_names[index])" :title="commentDetails.replied_user_names[index]" style="float:inline-start;">{{ commentDetails.replied_user_names[index].split("")[0] }}</div> 
                                </div>    
                            </template>
                        </div>
                        <div v-else v-for="user in commentDetails.replied_user_names" :key="user" class="user-name-or-image user-name" :style="style(user)" :title="user" style="float:inline-start;">{{ user.split("")[0] }}</div>
                        <!-- v-if=" Object.keys(commentDetails).includes('reply_count') &&  commentDetails.reply_count > 0" -->
        
                        <div v-on:click="openReplyThread(commentDetails)" class="replies-count" :style="getReplyCount(commentDetails.reply_count)!= 0?'display:block':'display:none'">{{getReplyCount(commentDetails.reply_count)}}</div>
                        
                    </div>
                    <div  v-if="Object.keys(commentDetails).includes('markers')">
                        <div class="markin-markout-imgs-div"><img draggable="false" :src="getThumbnail(commentDetails)" @error="replaceByDefaultImage" @dblclick="openPictureInPicture(commentDetails)" style="margin: 0px !important;display: block;max-width: 320px;max-height: 180px;width: auto;height: auto;" /> </div>
                    </div>
                </div>
                <div class="parent-comment-options-wrapper">
                    <svg v-show="commentDetails.user_id == this.getLoggedInUserId()" @click.stop.prevent="editParentComment(commentDetails)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pen-fill" viewBox="0 0 16 16">
                        <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
                    </svg>
        
                    <svg  v-on:click.stop.prevent="openReplyThread(commentDetails)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chat-dots" viewBox="0 0 16 16">
                        <path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                        <path d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9.06 9.06 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.437 10.437 0 0 1-.524 2.318l-.003.011a10.722 10.722 0 0 1-.244.637c-.079.186.074.394.273.362a21.673 21.673 0 0 0 .693-.125zm.8-3.108a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6c0 3.193-3.004 6-7 6a8.06 8.06 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a10.97 10.97 0 0 0 .398-2z"/>
                    </svg>
                    <svg v-show="commentDetails.user_id == this.getLoggedInUserId()" @click.stop.prevent="deletecommentRequest()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16">
                        <title>{{$t('Delete')}}</title>
                        <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
                    </svg>
                </div> 
                <div class="col-md-1" style="text-align:center;padding:0px !important">
                    <svg v-if="commentDetails.status == 'Open'" @click.prevent.stop="updateCommentStatus()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#e8912d" class="bi bi-clock-fill" viewBox="0 0 16 16">
                        <title>{{$t('Open')}}</title>
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                    </svg>
                    <svg v-if="commentDetails.status == 'Close'" @click.prevent.stop="updateCommentStatus()" xmlns="http://www.w3.org/2000/svg" width="16" height="16"  fill="green" class="bi bi-check-circle-fill mt-1" viewBox="0 0 16 16">
                        <title>{{$t('Close')}}</title>
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                    </svg>   
                </div>
            </div>
            <div v-else class="comm-comment-wrapper w-100 d-flex">
                <div class="d-inline-flex" style="width:100%;">
                    <!-- <div v-if="Object.keys(commentDetails).includes('profile_image') && !['undefined', undefined,null].includes(commentDetails.profile_image) && commentDetails.profile_image" v-html="getProfileImageOfUser(commentDetails.profile_image)" class='col-1 user-name-or-image user-name' style="padding:0px !important">
                    </div> -->
                     <div v-if="Object.keys(commentDetails).includes('profile_image') && !['undefined',undefined,null].includes(commentDetails.profile_image) && commentDetails.profile_image">
                        <div v-for="(value, key) in commentDetails.profile_image" :key="key"> 
                            <div v-if="!['undefined',undefined,null].includes(value)"> 
                                <div class='user-name-or-image user-name' style="float:inline-start;display:inline-block;">
                                    <img :src="getProxyConvertedURL(commentDetails.profile_image[key])" @error="replaceWithUserIcon($event,commentDetails.username)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                                </div> 
                            </div>  
                            <div v-else class="user-name-or-image user-name" :style="style(commentDetails.username)" :title="commentDetails.username" style="top:1px !important">{{ commentDetails.username.split("")[0] }}</div>  
                        </div>       
                    </div>
                    <div v-else class="col-1 user-name-or-image user-name" :style="style(commentDetails.username)" style="width:40px;margin-inline-start: 7px;margin-top: 5px;padding: 0px !important">{{ commentDetails.username.split("")[0] }}</div>
                    <div class="col-11" style="text-align:start;padding: 0px !important">
                        <div style="display:flex;">{{commentDetails.username}}
                            <div class="commented-date" style="position:relative;inset-inline-start:8px;top:4px;font-size:11px">{{getDateAndTimeInConfiguredFormat(commentDetails.created_datetime)}}</div>
                        </div>
                        <div v-show="isReplyCommentEdit == true">
                            <add-comment  @replyPostData="updateCommentAction" @closeEditingComment="closeReplyCommentEdit(commentDetails.comment)" :commentDataToEdit="editCommentData"  :buttonRequiredList="['updateComment', 'cancelUpdateComment']"  :replyContext="true" :idOfParentComment= idOfParentComment :commentDetails= commentDetails></add-comment>
                        </div>
                        <div v-show="isReplyCommentEdit != true" class="comment-data-div comment-text-cursor" v-html="urlify(commentDetails.comment)"></div>
                         <div v-if="commentDetails.attachments_info && commentDetails.attachments_info.length" class='attachments-in-message'>
                            <template v-for="attachment in commentDetails.attachments_info">
                                <div v-if="Object.keys(attachment).length" :key="attachment._id" :title="attachment.file_name" v-on:dblclick="openPictureInPicture(attachment)" style="display: block;width:340px;">
                                    <div v-if="attachment.proxy_info.thumbnail_uri != undefined && attachment.proxy_info.thumbnail_uri.length" class="thumbnail-view" style="display: flex;width: 345px;justify-content: center">
                                        <img draggable="false" :src="getThumbnail(attachment)" @error="replaceByDefaultImage" style="border-radius: 5px;width:100%"/> 
                                        <div v-if="attachment.state && attachment.state == 'OUTDATED'" class="outdated-text">
                                            {{$t('OUTDATED')}}
                                        </div>
                                        <div class="storage-type-icons-wrapper">
                                            <svg @click="openPictureInPicture(attachment)" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#a3adad">
                                                <path d="M0 0h24v24H0V0z" fill="none"/>
                                                <title>{{$t('Preview')}}</title>
                                                <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                                            </svg>
                                            <svg v-if="isActionEnable('Download')" @click.stop.prevent="handleDownloadAction(attachment)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                                                <title>{{$t('Download')}}</title>
                                                <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                                <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                            </svg>
                                            <svg v-if="attachment.state && attachment.state == 'OUTDATED' && getVersionInfoDisplayCheck" v-on:click.stop.prevent="openManageVersions(attachment)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-files" viewBox="0 0 16 16">
                                                <title>{{$t('View versions')}}</title>
                                                <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                                            </svg>
                                        </div>
                                    </div>
                                    <div
                                    v-else
                                    class="svg-icons-display-wrapper"
                                    style="height: 200px;display: flex;width: 100%;justify-content: center;position:relative"
                                    >
                                    <div v-if="attachment.state && attachment.state == 'OUTDATED'" class="outdated-text">
                                        {{$t('OUTDATED')}}
                                    </div>
                                    <div class="svg-icons-display" style="width:90px !important;height:90px !important" v-html="getSvgIconsOfMediaTypes(attachment)"></div>
                                     <div class="storage-type-icons-wrapper">
                                        <svg v-if="isActionEnable('Download')" @click.stop.prevent="handleDownloadAction(attachment)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                                            <title>{{$t('Download')}}</title>
                                            <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                            <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                        </svg>
                                        <svg v-if="attachment.state && attachment.state == 'OUTDATED' && getVersionInfoDisplayCheck" v-on:click.stop.prevent="openManageVersions(attachment)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-files" viewBox="0 0 16 16">
                                            <title>{{$t('View versions')}}</title>
                                            <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                                        </svg>
                                    </div>
                                    </div> 
                                    <div style="display:flex;" :title="attachment.file_name">
                                        <div class="svg-icons-display" v-html="getSvgIconsOfMediaTypes(attachment)">                              
                                        </div>
                                        <div style=" margin-top: 7px; text-align: start;white-space: nowrap;width: 100%;overflow: hidden;text-overflow: ellipsis;font-size:12px;margin:9px;margin-inline-start:0px">
                                            {{attachment.file_name}}
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <!-- <div class="commented-date">{{moment.utc(commentDetails.created_datetime).format("DD/MM/YYYY h:mm:ss a")}}</div> -->
                    </div>
                </div>
                <div class="reply-comment-options-wrapper">
                    <svg v-show="commentDetails.user_id == this.getLoggedInUserId()" @click.stop.prevent="checkForUnsavedDescription(), editReplyComment(commentDetails)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                        <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
                    </svg>
                    
                    <svg v-show="commentDetails.user_id == this.getLoggedInUserId()" @click="checkForUnsavedDescription(), deleteReplyCommentRequest(commentDetails)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                        <title>Delete</title>
                        <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
                    </svg>
                </div> 
            </div>
        </div>
    </div>
</template>

<script>
import Utils from "../../components.utils.js";
import {mapActions, mapMutations, mapGetters} from 'vuex';
import AddComment from "./AddCommentTextArea.vue";
import Constants from "../../components.constants.js"

export default {
   name:'Comments',
   props:['commentDetails','enableMinimalData', 'reviewDetails', 'idOfParentComment',"commentModule" , "isTicket"],
   data(){
       return {
           stylesFromParent:{minimalInfo:false},
           replyCount : 0,
           activeCommentIndex:null,
           isCommentEdit: false,
           isReplyCommentEdit:false,
           idRepluyContextUpdate : false,
           editCommentData:"",
        //    selectedFileToViewVersions:null,
        //    openVersionDisplayDialog:false
       };
   },

   components:{
       "add-comment":AddComment,
        // "manage-version":ManageVersionsDialog
   },

    mounted(){
    },
    computed:{
            ...mapGetters("versions",["getVersionInfoDisplayCheck"]),
            ...mapGetters('users',["getLoggedInUserPrivilege"])
    },
    methods:{
        openManageVersions(file){
          this.$emit('openManageVersions',file)
        },
        // closeVersionDisplayDialog(){
        //     this.openVersionDisplayDialog = false;
        //     this.selectedFileToViewVersions = null;
        // },
        replaceByDefaultImage(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
        openPictureInPicture(info){
            this.$emit("openPictureInPicture",info)
        },
        openPreviewOfMedia(fileInfo){
            this.$emit("openPictureInPicture",fileInfo)
        },
        handleDownloadAction(fileInfo){
            let payload = {};
            if(fileInfo.parent_path){
                payload.bin_id = Utils.getBinIdFromPath(fileInfo.parent_path);
            }else if(fileInfo.parent_id_path){
                payload.bin_id = Utils.getBinIdFromPath(fileInfo.parent_id_path);
            }
            payload.element_type = "file";
            payload.job_name = "Download";
            payload.file_name = fileInfo.file_name;
            payload.path = fileInfo.path;
            let fileName = fileInfo.file_name;
            this.initiateDownloadJob(payload).then((data) => {
                let jobIdFromResponse = data.job_id;
                let payload = { job_id: "job_id=" + jobIdFromResponse };
                let downnloadUrl = `${Constants.downloadUrl}?${payload.job_id}`;
                const link = document.createElement("a");
                link.href = downnloadUrl;
                link.download = fileName;
                link.click(); 
                if (Utils.isAcceptedStatusCode(data.statusCode) == 200) {
                    console.log("Share asset Download initiated");
                } else {
                    this.$toast.error(data.message);
                }
            });
        },
        isActionEnable(priv){
            return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege,priv)
        },
        getSvgIconsOfMediaTypes(path, type) {
            return Utils.determineSvgIconForType(path, type);
        },

        style(name) {
            let style = {
                color: this.textColor(this.intToRGB(this.hashCode(name))),
                "background-color": "#" + this.intToRGB(this.hashCode(name)),
            };
            return style;
        },
        getProfileImageOfUser(image){
            let defaultImage = Utils.getNoThumbnailImg()
            let profileImageTag = '<img src='+this.getProxyConvertedURL(image)+' onerror="this.src='+defaultImage+'; this.onerror = null"  style="width:100%;height:100%;border-radius:6px">'
            return profileImageTag;
        },
        replaceWithUserIcon(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
        hashCode(str) {
            var hash = 0;
            if (str != undefined) {
                for (var i = 0; i < str.length; i++) {
                    hash = str.charCodeAt(i) + ((hash << 5) - hash);
                }
            }
            return hash;
        },
        intToRGB(i) {
            var c = (i & 0x00ffffff).toString(16).toUpperCase();
            return "00000".substring(0, 6 - c.length) + c;
        },
        textColor(hexcolor) {
            // If a leading # is provided, remove it
            if (hexcolor.slice(0, 1) === "#") {
                hexcolor = hexcolor.slice(1);
            }

            // Convert to RGB value
            var r = parseInt(hexcolor.substr(0, 2), 16);
            var g = parseInt(hexcolor.substr(2, 2), 16);
            var b = parseInt(hexcolor.substr(4, 2), 16);

            // Get YIQ ratio
            var yiq = (r * 299 + g * 587 + b * 114) / 1000;

            // Check contrast
            return yiq >= 128 ? "black" : "white";
        },
        getThumbnail(fileInfo = {}){
            // if(fileInfo && Object.hasOwnProperty.call(fileInfo,'markers') && fileInfo.markers.frame_thumbnail_uri)
            // return fileInfo.markers.frame_thumbnail_uri

            return Utils.getThumbnailPathfromFileInfo(fileInfo);
        },
        urlify(text) {
            text = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g,'&gt;')
            var mentionsRegex = /\B@[a-z0-9_-]+/gi;
            let that = this;
            text = text.replace(mentionsRegex,function(mention){
                let temp = mention.substr(1);
                if(temp == that.getLoggedInUser()){
                    return '<span style="border-radius: 15px;padding: 3px 7px;background: #007373c9;color: #eee;">' + mention + '</span>';
                }else{
                    return '<span style="border-radius: 15px;background: transparent;color: #2cbdbd;">' + mention + '</span>';
                }
            })
            var urlRegex = /(https?:\/\/[^\s]+)/g;
            return text.replace(urlRegex, function(url) {
                return '<a href="' + url + '" target="_blank" style="overflow-wrap: anywhere;color:#1d9bd1">' + url + '</a>';
            })
        },

        checkForUnsavedDescription(){
            if(this.commentModule == "Task") {
                this.$emit("checkIsUnsavedDescriptionComment", true);
            }
        },

        openReplyThread(commentInfo){    //this function is for - reply click
            if(document.getElementsByClassName('activeComment').length >0){
                document.getElementsByClassName('activeComment')[0].classList.remove("activeComment");
            }
            document.getElementById(this.commentDetails._id).classList.add("activeComment");
            this.activeCommentIndex = commentInfo._id;
            this.$emit("openThread",commentInfo);
        },
         
        editParentComment(commentInfo){
            if(commentInfo.user_id == this.getLoggedInUserId()){
                this.isCommentEdit = true;
                console.log(commentInfo)
                this.editCommentData = commentInfo.comment;
            }else{
                this.$toast.error("Not allowed to Edit Comment created by others.");
                return false;
            }    
            // this.$emit("editingCommentData", commentInfo.comment);
        }, 

        editReplyComment(commentInfo){
            if(commentInfo.user_id == this.getLoggedInUserId()){
                this.isReplyCommentEdit = true;
                console.log(commentInfo)
                this.editCommentData = commentInfo.comment;
                // this.editReplyComment = true;
            }else{
                this.$toast.error("Not allowed to Edit Comment created by others.");
                return false;
            }    
            // this.$emit("editingCommentData", commentInfo.comment);
        }, 
         
        updateCommentStatus(){
            if(this.commentDetails.status == "Open"){
                this.commentDetails.status = "Close"
            }else{
                this.commentDetails.status = "Open"
            }
            this.$emit("commentStatus", this.commentDetails);
        },

        updateCommentAction(commentPutData){
           let payload={};
            // payload = this.proxyConfig;
            // payload.params = commentPostdata;
            let selectedReviewId = this.reviewDetails._id;
            payload.reviewId = selectedReviewId;
            payload.commentModule = this.commentModule;
            if(this.isTicket == true){
                payload.taskType = "Ticket";
            }
            let commentObj = {};
            commentObj["status"] = this.commentDetails.status;
            commentObj["pid"] = commentPutData.pid;
            commentObj["_id"] = this.commentDetails._id;
            commentObj["edit"] = true;
            commentObj["user_id"] = commentPutData.user_id;
            commentObj["comment"] = commentPutData.comment;
            payload.params = commentObj;
            this.updateCommentData(payload).then((data) => {
                console.log(data)
                if (Constants.acceptedStatusCodes.includes(data.status_code)) {
                    this.$toast.success("Comment updated");
                    // this.$toast.success(data.message);
                } else {
                    this.$toast.error(data.message);
                }
            });
            if(commentPutData.pid == 0){
                this.isCommentEdit = false;
                if(this.isReplyCommentEdit == true){
                    // this.editReplyComment = false;
                    this.isReplyCommentEdit = false;
                }
            }else{
                // this.editReplyComment = false;
                this.isReplyCommentEdit = false;
            }
        },

        closeCommentEdit(comment){
            this.isCommentEdit = false;
            this.editCommentData = comment;
        },

        closeReplyCommentEdit(comment){
            this.isReplyCommentEdit = false;
            this.editCommentData = comment;
        },

        deletecommentRequest(){
            this.$emit("commentDelete", this.commentDetails);
        },

        deleteReplyCommentRequest(commentInfo){
            this.$emit("replyCommentDelete", commentInfo);
        },

        getReplyCount(replyCountValue){
            let replyCount = 0;
            if(replyCountValue == 1){
                replyCount = replyCountValue +" Reply";
            }else if(replyCountValue > 1){
                replyCount = replyCountValue +" Replies";
            }
            return replyCount;
        },

        displayProxyOfFile(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            let proxy_data = notification.message;
            try{
                if(this.commentDetails){
                        if(this.commentDetails.attachments && Array.isArray(this.commentDetails.attachments)){
                            let cmtIndex = this.commentDetails.attachments_info.findIndex(e => e.file_uid == proxy_data.file_uid);
                            if(cmtIndex >= 0){
                                this.commentDetails.attachments_info.splice(cmtIndex,1,proxy_data);
                            }
                        }
                }
            }catch(e){
                console.log('error to update chat list:',e);
            }
        },
        
         getDuplicatesObject(list){
            let duplicateMap = {};
            for(let i = 0; i < list.length; i++){
                if(!Object.prototype.hasOwnProperty.call(duplicateMap,list[i])) duplicateMap[list[i]] = 0;
                duplicateMap[list[i]] += 1;
            }
            return duplicateMap;
        },
        // handleReplyCountUpdateNotification(notification){
            // notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        //     let replyCountInfo = notification.message;
        //     if(this.commentDetails._id == replyCountInfo._id){
        //         this.commentDetails["reply_count"] = replyCountInfo.reply_count;
        //         this.commentDetails["replied_user_ids"] = replyCountInfo.replied_user_ids;
        //         this.commentDetails["replied_user_names"] = replyCountInfo.replied_user_names;
        //         this.commentDetails["replied_profile_images"] = replyCountInfo.replied_profile_images;
        //     }
        // },

        registerforWebsocketNotifications(){
            
        //    this.addWSEventListener({
        //       eventname:["REPLY_COUNT_CHANGED"],
        //       callback:this.handleReplyCountUpdateNotification,
        //       parent: "review"});  
              
            this.addWSEventListener({
              eventname:["TASK_REPLY_COUNT_CHANGED"],
              callback:this.handleReplyCountUpdateNotification,
              parent: "review"});  
              
            this.addWSEventListener({
                eventname:"FILE_UPDATED",
                callback:this.displayProxyOfFile,
                parent:"review"});   
        },
        unRegisterforWebsocketNotifications(){
            
        //    this.removeWSEventListener({
        //       eventname:["REPLY_COUNT_CHANGED"],
        //       callback:this.handleReplyCountUpdateNotification,
        //       parent: "review"});  
              
            this.removeWSEventListener({
              eventname:["TASK_REPLY_COUNT_CHANGED"],
              callback:this.handleReplyCountUpdateNotification,
              parent: "review"}); 

            this.removeWSEventListener({
                eventname:"FILE_UPDATED", 
                callback:this.displayProxyOfFile,
                parent:"review"});    
            },
        ...mapActions("reviewDataTemp", ["updateCommentData"]),
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        ...mapGetters("users",["getLoggedInUser","getLoggedInUserId"]),
        ...mapActions("download", ["initiateDownloadJob", "downloadFile"]),
    },
    

   emits: ["openThread", "commentStatus", "commentDelete", "editingCommentData","replyCommentDelete"],

    watch: {
        "$route.fullPath" : function(){
            let obj = {};
            if(![undefined, null].includes(this.$route.params.ticketReplycommentId)){
                this.activeCommentIndex = this.$route.params.ticketReplycommentId;
                obj = document.getElementById(this.$route.params.ticketReplycommentId);
            }else if(![undefined, null].includes(this.$route.params.taskReplycommentId)){
                this.activeCommentIndex = this.$route.params.taskReplycommentId;
                obj = document.getElementById(this.$route.params.taskReplycommentId);
            }else if(![undefined, null].includes(this.$route.params.issueReplycommentId)){
                this.activeCommentIndex = this.$route.params.issueReplycommentId;
                obj = document.getElementById(this.$route.params.issueReplycommentId);
            }else if(![undefined, null].includes(this.$route.params.boardReplycommentId)){
                this.activeCommentIndex = this.$route.params.boardReplycommentId;
                obj = document.getElementById(this.$route.params.boardReplycommentId);
            }
            console.log(obj);

            
              //to highlight the comment omn page refresh
            //   obj.setAttribute("style", "background: #22272b; transition: .5s;"); //#333537
            //   setTimeout(()=>{
            //       obj.setAttribute("style", "background: transparent;transition: .5s;");
            //   },800)    
        },
    },

   created(){
       this.registerforWebsocketNotifications();
   },
   beforeDestroy(){
       this.unRegisterforWebsocketNotifications()
   }
}
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $panel-heading-font-size:18px;
    $secondary-border-color: 1px solid #2b2b2b;

.commented-date{
    font-size: 13px;
    color:$dull-text-color;
}

.replied-by-wrapper{
    display:inline-flex;
    margin: 7px 0px;
}

.comm-comment-wrapper{
    border-bottom: $secondary-border-color;
    padding: 8px 5px;
    position:relative !important;
}
.comm-comment-wrapper:hover{
    background: $bg-color-on-hover;
}
.user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
}

.user-name{
    margin-inline-end: 5px;
}

.replies-count{
    margin: auto;
    color: #1d9bd1;;
}
.replies-count:hover{
    text-decoration: underline;
}

img{
   margin: 0px 8px 8px 0px;
}

.user-image-small-size{
    width: 43px !important;
    height: 25px;
    line-height: 22px !important;
}

.parent-comment-options-wrapper, .reply-comment-options-wrapper{
    visibility: hidden;
    position: absolute;
    inset-inline-end: 70px;
    top: 4px;
    // border: $border-color;
    // border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:2px;
    z-index: 11111;
    svg{
    //    width: 22px;
    //     height: 22px;
    //     padding: 3px;
    //     // margin: 3px 0px 3px 3px;
    //     border-radius: 4px;

        margin: 2px;
        background: rgba(209,210,211,.10196078431372549);
        padding: 5px;
        height: 28px;
        width: 28px;
        border-radius: 4px;
        margin-inline-end: 5px;
        color: silver;
    }
    svg:hover {
        background: #fdfeff54 !important;
    }
}


.reply-comment-options-wrapper{
    inset-inline-end:10px;
}
.parent-comment-options-wrapper, .reply-comment-options-wrapper{
    svg:hover{
        background: $bg-color-on-hover;
    }
}    

.comm-comment-wrapper:hover{
    .parent-comment-options-wrapper{
        visibility:visible;
    }
}


.comm-comment-wrapper:hover{
    .reply-comment-options-wrapper{
        visibility:visible;
    }
}

.markin-markout-imgs-div{
    // height: 90px;
    // width: 160px;
    display: flex;
    align-items: center;
    float: inline-start;
    margin-inline-end: 10px;
}

.activeComment .comment-details-div{
    color: $text-color!important;
    font-weight: 500;
    font-size:15px;
    // border: 1px solid #007bff !important;
    color: $active-blue!important;
}
.comment-data-div{
    min-height:25px;
    color:$secondary-text-color;
    white-space: pre;
}

.comment-text-cursor{
    color: $text-color;
    white-space: pre-wrap;
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
    cursor: auto;
    word-break: break-word;
}

.svg-icons-display-wrapper{
    align-items: center;
    border: $border-color;
    border-radius: 7px;
    .svg-icons-display{
        height: 70px !important;
        width: 70px !important;
        margin: 12% auto;
    }
}

.svg-icons-display {
  height: 20px;
  width: 20px;
  position: relative;
  opacity: 0.8;
  inset-inline-end: 5px;
}

.attachments-in-message{
    list-style-type: none;
    display: inline-flex;
    flex-wrap: wrap;
    padding: 0;
    margin-top: 0;
    width: 100%;
    justify-content: start;
    overflow: auto;
    div{
        margin: 5px;
    }
    img{
        margin: 0px 8px -4px 0px;
    }
}

.storage-type-icons-wrapper{
    visibility: hidden;
    color: #999;
    background: #000000c9;
    min-width: 30px;
    width: auto;
    border-bottom-right-radius: 4px;
    border-top-left-radius: 4px;
    position: absolute;
    top: 6px;
    inset-inline-end: 6px;
    line-height: 1;
    margin-inline-start: 8px;
    border: unset;
    --saf-0: rgba(var(--sk_foreground_low,29,28,29),0.13);
    box-shadow: 0 0 0 1px var(--saf-0),0 1px 3px 0 rgba(0,0,0,.08);
    display: flex;
    padding: 5px;
    border-radius: 0.375em;
    justify-content: space-evenly;
    width: auto;
    svg{
        margin: 0px 4px;
    }
    a#bd-versions:hover {
        background: transparent;
        border-radius: 0px;
    }
}

.thumbnail-view:hover,.svg-icons-display-wrapper:hover{
    .storage-type-icons-wrapper{
        visibility: visible;
    }
}

.thumbnail-view,.svg-icons-display-wrapper{
  position:relative;
}

.outdated-text{
    position: absolute;
    top: 0px;
    font-weight: 500;
    background: #cf7f06;
    z-index: 0;
    width: 79px;
    text-align: center!important;
    height: 26px;
    padding-top: 3px;
    inset-inline-start:0px;
    font-size: 13px;
    border-radius: 5px;
}

</style>